// Low-value "hometown connection" perk (plans/i-think-i-want-rosy-stream.md
// follow-up, added once real San Rafael tile data was pulled and inspected):
// a profession can carry a `poiReveal` matcher (see professions-v4.mjs) that
// points at one real building on the current map — e.g. a mechanic reveals
// an actual auto-repair shop tagged in OpenStreetMap.
//
// FUTURE: if nothing on the tile matches, this just reveals nothing — that's
// intentional (the in-universe explanation is "they commute to a different
// tile," these tiles are small). A nice follow-up once this is played more:
// weight the random profession pick toward professions whose building
// actually exists on this tile, so more survivors end up with a visible
// connection instead of leaving it to chance. Not built — future problem.

// Matches a building GeoJSON feature (see building-geojson.mjs's flat
// properties shape: amenity/shop/building are plain strings) against a
// profession's poiReveal spec. Any one matcher matching is enough (OR).
function buildingMatches(poiReveal, feature) {
  const props = feature?.properties || {};
  return poiReveal.matchers.some(({ tag, value }) => props[tag] === value);
}

// All buildings on this tile that a given poiReveal spec could point at.
export function findRevealCandidates(poiReveal, buildingFeatures) {
  if (!poiReveal || !Array.isArray(buildingFeatures)) return [];
  return buildingFeatures.filter((feature) => buildingMatches(poiReveal, feature));
}

// Pick one matching building for this profession on this tile, or null if
// none exist here. `rng` defaults to Math.random; pass a seeded stub for
// deterministic campaign generation (matches the rest of the codebase's
// seeded-random convention) or for tests.
export function findRevealBuilding(poiReveal, buildingFeatures, rng = Math.random) {
  const candidates = findRevealCandidates(poiReveal, buildingFeatures);
  if (!candidates.length) return null;
  const index = Math.min(candidates.length - 1, Math.floor(rng() * candidates.length));
  return candidates[index];
}
